import ComponentHeader from '../main/ComponentHeader';
import {Box, Input, InputGroup, InputLeftElement, Spacer, Stack, useToast, Button, Table,Thead,Tbody,Tr,Th,Td,TableContainer,Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody} from '@chakra-ui/react'
import { SearchIcon, SmallAddIcon } from '@chakra-ui/icons';
import GruntComponents from '../components';
import { useState, useEffect, useCallback } from 'react';
import { loggedOper as lp } from '../../util/grunt';
import GruntPager from '../custom/GruntPager';
import { getDrzave, addDrzava, updateDrzava, Drzava } from "../../util/apiDrzava";
import DrzavaView from './DrzavaView';
//import KlaonicaControl from './KlaonicaControl';


const Drzave = ({onClosePress,size='xs'}) => {
    const [state, setState] = useState({drzave:[]});
    const [prikaz, setPrikaz] = useState({orderbycol:"id",orderby:"asc",drzaveprikaz:[],rowsperpage:20,currpage:1, newDrzava:false, showDrzava:false,selectedDrzava:{},fetchdrzave:0});
    const userCanEdit=lp.uloga==="r"?false:true;
    const toast=useToast();
    const fetchDrzave=useCallback(async()=>{
        try {
            
            let res=await getDrzave();
            if (res.status===200) {
               /* setState({...state,drzave:res.res});        
                setPrikaz({...prikaz,drzaveprikaz:res.res}); */
                setState(prev => ({...prev, drzave: res.res}));        
                setPrikaz(prev => ({...prev, drzaveprikaz: res.res})); 

            } else {
                throw new Error(res.message);
            }
            
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka.",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        }
        
    },[]);

    useEffect(() => {
        fetchDrzave();
        
    }, [prikaz.fetchdrzave]);

    useEffect(() => {
        const Sort=()=>{
            const asc=prikaz.orderby==="asc";
            let _b;
            let _os=[...state.drzave].sort((a,b)=>{
                if (prikaz.orderbycol==="sifra") {
                  _b=a.sifra>b.sifra;
                } else if (prikaz.orderbycol==="naziv") {
                    _b=a.naziv>b.naziv;
                } 

                return asc?(_b?1:-1):(_b?-1:1);
            });
            //setPrikaz({...prikaz,drzaveprikaz:_os}); 
            //setState(prev => ({...prev, drzave: res.res}));        
            setPrikaz(prev => ({...prev, drzaveprikaz: _os})); 

        }
        Sort();
    }, [prikaz.orderbycol, prikaz.orderby,state.drzave]);

    const btnNew=()=>{
        if (userCanEdit) {
            return (
                 <Button rightIcon={<SmallAddIcon/>} colorScheme={'grunt2'} variant={'outline'} size={size} 
                 onClick={newDrzava}>Dodaj</Button>
                )
        } else {
            return (
                <></>
                )
        }
    }

    

    const newDrzava=()=>{
        const _dz=new Drzava();
        setPrikaz({...prikaz,newDrzava:true,selectedDrzava:_dz})
    }
    const getOrderImage=(propname)=>{
        let _res=" ⋮";
        if (propname.toLowerCase()===prikaz.orderbycol){
            _res=" ▴"
            if (prikaz.orderby==="desc") {
                _res=" ▾"
            }
        } 
        return _res;
    }
    
    
    const FilterData=(filter)=>{
        const _val=filter.target.value.toLowerCase();
        let _o=state.drzave.filter((drzava)=>{
            return (drzava.sifra.toLowerCase().includes(_val) ||  drzava.naziv.toLowerCase().includes(_val) );
        });
        setPrikaz({...prikaz,drzaveprikaz:_o,currpage:1}); 
    }

    const closeDrzavaControl=()=>{
        setPrikaz({...prikaz,newDrzava:false,showDrzava:false,selectedDrzava:{}})
    }

    

    const getDrzavaControl=()=>{
        if (prikaz.showDrzava  || prikaz.newDrzava) {
            return (
                <Drawer placement='right' size={'sm'} isOpen={true}>
                <DrawerOverlay/>
                <DrawerContent roundedTopLeft={'md'}>
                    <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                        Država
                    </DrawerHeader>
                    <DrawerBody>
                            {/* <KlaonicaView klaonica={klaonica} readonly={readonly} onCancel={onCloseControl} onSave={onSave}/> */}
                            <DrzavaView drzava={prikaz.selectedDrzava} readonly={!userCanEdit} onCancel={closeDrzavaControl} onSave={saveDrzava}/>
                    </DrawerBody>
                </DrawerContent>
                </Drawer>
            )
        }
    }
    const selectDrzava=(dzid)=>{
        const _dz=prikaz.drzaveprikaz.find((item)=>item.id===dzid);
        const _d= new Drzava(_dz.id,_dz.sifra,_dz.naziv);
        setPrikaz({...prikaz,selectedDrzava:_d,showDrzava:true});
    }
    const saveDrzava=async (dz)=>{
       try {
            let res;
            if (dz.id===0) { //unos nove drzave
                res=await addDrzava(dz);
            } else { //ispravak podataka postojeće klaonice
                res=await updateDrzava(dz);
            }
            if (res.status===200) {
 
                setPrikaz({...prikaz,newDrzava:false,showDrzava:false,selectedDrzava:{},fetchdrzave:prikaz.fetchdrzave+1})
                toast({
                    title:"Podatak spremljen",
                    status:"success",
                    isClosable:true,
                    duration:1500,
                    position:"top-right",
                });
            } else {
                if (res.code==="23505") {
                    throw new Error("Šifra države već je unesena.");    
                } else {
                    throw new Error(res.message);
                }
            }
       } catch (ex) {
        toast({
            title:"Greška kod unosa",
            status:"error",
            description:ex.message,
            isClosable:true,
            duration:2000,
            position:"top-right",
        });
       }
    }
    
    
    const ShowGruntPager=()=>{
        if (prikaz.drzaveprikaz.length>0) {
            return (
                 <GruntPager currpage={prikaz.currpage} rowcount={prikaz.drzaveprikaz.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                 );    
                
        }
        
    }
    
    return (
        <Box display={'flex'} flex={1} flexDir={'column'} h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl='0.5rem' pr={'0.5rem'} pb={'0.2rem'}>
           
                <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Drzave}/>
           
            
            <Box  display={'flex'} flexDir={'row'} alignItems={'center'} mb={'1rem'}>
                    <InputGroup size={'xs'} w='20rem'>
                        <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                        <Input focusBorderColor='grunt2.400' placeholder='Filter' maxLength={'20'} onChange={FilterData}/>
                    </InputGroup>
                  
                    <Spacer/>
                    <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}>
                        {btnNew()}
                    </Stack>
                    
            
            </Box>
            <Box display={'flex'} flexDir={'column'} overflowY={'auto'} flex={1}>
                <TableContainer  overflowY={'auto'} className='noscroll'>
                    <Table variant={'unstyled'} size='sm'>
                        <Thead _hover={{cursor:'pointer'}}>
                            <Tr>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"sifra",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Šifra{getOrderImage("sifra")}</Th>
                                <Th w={'70%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'} onClick={()=>setPrikaz({...prikaz,orderbycol:"naziv",orderby:prikaz.orderby==="asc"?"desc":"asc"})}>Naziv{getOrderImage("naziv")}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                        {prikaz.drzaveprikaz.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                             return (
                                <Tr  color={'grunt2'} key={item.id}  bg={'white'} fontWeight={'normal'} 
                                _hover={{bg:'gray.100',cursor:'pointer'}} onClick={()=> selectDrzava(item.id)} h='2rem'>
                                    <Td textAlign={'center'}>{item.sifra}</Td>
                                    <Td textAlign={'center'}>{item.naziv}</Td>
                                </Tr>
                             )
                        })}
                        </Tbody>
                        </Table>
                </TableContainer>
                </Box>
                <Box display={'flex'} flexDir={'row'} justifyContent={'center'}>
                        {ShowGruntPager()}
                </Box>
                {getDrzavaControl()}
                
            </Box>
    );
}

export default Drzave;
